/* Rückfrage vor unwiderruflichen Aktionen.
 *
 * Weder die ursprüngliche Fassung noch der erste Umbau hatten eine einzige
 * Rückfrage — ein Fehlklick neben einem Reisepass-Scan löschte ihn sofort und
 * endgültig aus dem Speicher. Es gibt kein Rückgängig und keinen Papierkorb.
 *
 * Verwendung:
 *   const { confirm } = useConfirm();
 *   if (!(await confirm({ title: …, message: … }))) return;
 *
 * Der Zustand liegt im Modulbereich; der Dialog selbst hängt einmal in
 * App.vue (ConfirmDialog.vue).
 */

import { ref } from 'vue';

const state = ref(null);
let resolver = null;

export function useConfirm() {
  /**
   * @param {object}  options
   * @param {string}  options.title    Überschrift
   * @param {string}  options.message  Was passiert, in Klartext
   * @param {string} [options.detail]  Zusatz, etwa die Zahl betroffener Dateien
   * @param {string} [options.confirmLabel]
   * @param {boolean} [options.danger]  false = Bestätigen-Knopf ohne Warnfarbe (harmlose Aktion); Vorgabe true
   * @returns {Promise<boolean>}
   */
  function confirm(options) {
    state.value = { ...options };
    return new Promise((resolve) => {
      resolver = resolve;
    });
  }

  function answer(result) {
    state.value = null;
    resolver?.(result);
    resolver = null;
  }

  return { state, confirm, answer };
}
